// extracted by mini-css-extract-plugin
module.exports = {"currencyInfoWrapper":"styles_currencyInfoWrapper__pVNnn","big":"styles_big__qbAAj","currencyInfo":"styles_currencyInfo__u6zYY"};